export const IS_PUPPETEER =
    typeof window !== "undefined" &&
    window.navigator.userAgent.includes("HeadlessChrome");
